module.exports = __webpack_public_path__ + "img/Logo-Food-default.dbf35275.svg";